export const APP_VERSION = '3.1.2682';
